<template>
  <cancelled-form />
</template>

<script>
import CancelledForm from '@/views/borrows/cancelled/Form'

export default {
  name: 'Edit',
  components: { CancelledForm },
  metaInfo () {
    return {
      title: this.$t('string.editBorrower'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
